import SaveBeforeExitDialog from 'wb-reddit/app/common/components/saveBeforeExitDialog';
import useConfirmActionDialog, { IProps as IConfirmActionProps } from 'wb-reddit/app/routes/hooks/useConfirmAction';

type IProps = Omit<IConfirmActionProps, 'DialogComponent'>;

function useSaveBeforeExitDialog(props: IProps) {
	return useConfirmActionDialog({ ...props, DialogComponent: SaveBeforeExitDialog });
}

export default useSaveBeforeExitDialog;
